import { useTheme } from "@emotion/react";
import { Typography } from "@mui/material";

export const ErrorText = ({ children }) => {
  const theme = useTheme();
  return (
    <Typography
      variant="body2"
      sx={{
        fontSize: "0.875rem", 
        lineHeight: "1.4rem",
        color: theme.palette.error.main,
        mt: 1,
        textAlign: "center", 
      }}
    >
      {children}
    </Typography>
  );
};
